import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  config.headers['token'] = Vue.cookie.get('xjaf-token'); // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
});

export default http



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js